export default function getEmailBrandConfig() {
  const distributor = getDistributor();
  const runtime = useRuntimeConfig().public;
  return {
    imagekit: runtime.imagekit,
    devDomain: runtime.devDomain,
    websiteUrl: getDistributorWebsiteUrl(distributor) || runtime.websiteUrl,
    appName: distributor?.name || runtime.appName,
  };
}
